import type { DrawerRouteDefinition } from "shared-ui/src/components/detail-drawer/drawer-stack";

import { RoutedIntegrationTransferDrawer } from "./RoutedIntegrationTransferDrawer";
import { RoutedProductDrawer } from "./RoutedProductDrawer";
import { RoutedTrackingDrawer } from "./RoutedTrackingDrawer";
import {
  APPROVAL_DRAWER_SEGMENT,
  INTEGRATION_TRANSFER_DRAWER_SEGMENT,
  INVOICE_DRAWER_SEGMENT,
  ORDER_DRAWER_SEGMENT,
  ORDER_DRAWER_TABS,
  PRODUCT_DRAWER_SEGMENT,
  PRODUCT_DRAWER_TABS,
  TRACKING_DRAWER_SEGMENT,
} from "./orderDrawerSegments";

export {
  APPROVAL_DRAWER_SEGMENT,
  INTEGRATION_TRANSFER_DRAWER_SEGMENT,
  INVOICE_DRAWER_SEGMENT,
  ORDER_DRAWER_SEGMENT,
  PRODUCT_DRAWER_SEGMENT,
  TRACKING_DRAWER_SEGMENT,
} from "./orderDrawerSegments";

/**
 * Drawer kinds that live in the URL under any Customer Experience page. Base drawers have no
 * `component`: their owners render them with `useRoutedDrawer`. Stacked drawers name the
 * container `DrawerStackHost` renders for a pushed or deep-linked level. Containers import
 * their segments from `orderDrawerSegments.ts` to avoid an import cycle with this file.
 * Segments must not match any `App.tsx` path segment or tab id (guarded by
 * `drawerRouteSegments.test.ts`). The site prefix may match one: `OrderDrawerProvider`
 * passes it as the stack's `pathPrefix`.
 */
export const ORDER_DRAWER_ROUTES: readonly DrawerRouteDefinition[] = [
  { segment: ORDER_DRAWER_SEGMENT, tabs: ORDER_DRAWER_TABS },
  { segment: APPROVAL_DRAWER_SEGMENT },
  { segment: INVOICE_DRAWER_SEGMENT },
  {
    segment: PRODUCT_DRAWER_SEGMENT,
    tabs: PRODUCT_DRAWER_TABS,
    component: RoutedProductDrawer,
  },
  { segment: TRACKING_DRAWER_SEGMENT, component: RoutedTrackingDrawer },
  {
    segment: INTEGRATION_TRANSFER_DRAWER_SEGMENT,
    component: RoutedIntegrationTransferDrawer,
  },
];
